module.exports = __webpack_public_path__ + "media/images/scatter_plot-f3bfcc6a377958fe8ea2e3dc926d99f6.png";